module.exports = __webpack_public_path__ + "media/assets/images/flags/ad-e1996bcccbe936ae2126f78a656b9d80.svg";